const onClickCatalogSortBtnValue = ({ target }) => target.parentElement.classList.toggle('catalog-sort--open');
const catalogSortBtnValue = document.getElementById('catalogSortBtnValue');
if (catalogSortBtnValue) catalogSortBtnValue.addEventListener('click', onClickCatalogSortBtnValue);

// ============================================

const catalogFilterLink = document.getElementById('catalogFilterLink');
const changeCatalogFilterLink = (key, value) => {
  const url = new URL(catalogFilterLink.href);

  if (value) url.searchParams.set(key, value); else url.searchParams.delete(key);

  catalogFilterLink.href = url.toString();
  console.log(catalogFilterLink.href);
};

// ============================================

const catalogFilterBrand = document.querySelector('[data-filter="brand"]');
const catalogFilterModel = document.querySelector('[data-filter="model"]');

const hasBrandModel = catalogFilterBrand && catalogFilterModel;

if (hasBrandModel) {
  const onChangeCatalogFilterBrand = async ({ target }) => {
    catalogFilterModel.options.length = 1;
    catalogFilterModel.selectedIndex = 0;
    const brand = +target.value;

    if (brand) {
      const body = JSON.stringify({
        brand,
        category: target.dataset.category,
        search: target.dataset.search
      });

      try {
        const response = await fetch('/index.php?route=catalog/models', { method: 'POST', body });
        if (response.ok) {
          const data = await response.json();
          data.forEach(model => catalogFilterModel.options.add(new Option(model.name, model.id)));
        } else {
          throw new Error(`${response.status} ${response.statusText}`);
        }
      } catch (err) {
        console.error(err);
      }
    }

    changeCatalogFilterLink('brand', brand);
    changeCatalogFilterLink('model', null);
  };

  catalogFilterBrand.addEventListener('change', onChangeCatalogFilterBrand);
}

// ============================================

const catalogFilterList = document.querySelectorAll('[data-filter]');

if (catalogFilterList.length) {
  const onChangeCatalogFilter = ({ target }) => {
    const key = target.dataset.filter;
    let { value } = target;
    if (key === 'brand' && hasBrandModel) return;
    if (key === 'available') value = Number(target.checked);
    changeCatalogFilterLink(key, value);
  };

  catalogFilterList.forEach(el => el.addEventListener('change', onChangeCatalogFilter));
}

// ==================================

const onClickCatalogMobileBtnFilter = ({ target }) => {
  target.classList.toggle('catalog-mobile-btn-filter--open');
  document.querySelector('.layout-box__sort').classList.toggle('show');
};

const catalogMobileBtnFilter = document.getElementById('catalogMobileBtnFilter');
catalogMobileBtnFilter.addEventListener('click', onClickCatalogMobileBtnFilter);
